import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFileTypeDoc = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 4a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v4a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4zm8 1.414L16.586 7H15zM4 15a1 1 0 0 1 1-1h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H5a1 1 0 0 1-1-1zm2 1v4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m6.5 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5m-1.768-1.268A2.5 2.5 0 0 1 15 16.5v3a2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 .732-1.768m6 0A2.5 2.5 0 0 1 21 16.5a1 1 0 1 1-2 0 .5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0 1 1 0 1 1 2 0 2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 .732-1.768"
            clipRule="evenodd"
        />
    </svg>
);
